module.exports = __webpack_public_path__ + "icon_kerrostalo.4790c45b86df1ab3174a.svg";